import { kongApi } from 'packages/common/helpers/api';

const api = kongApi({
  baseURL: `${process.env.VUE_APP_BASE_URL_PERSONNEL_DEPARTMENT}/`,
});

export default {
  getPeriodValidation(period) {
    return api.head(`validations/periods?competence=${period}`);
  },
};
